export default "__VITE_ASSET__RDsEU8R___"